export function calculateTotalPages(total: number, limit: number): number {
  if (limit <= 0) return 0;
  return Math.ceil(total / limit);
}

export function calculateSkip(page: number, limit: number): number {
  return (page - 1) * limit;
}
